import { useQuery } from '@tanstack/react-query';

// helpers
import { BaseError } from '../../helpers/BaseError';
import { convertStringValues } from '../../helpers/objectHelper';

// models
import { FeatureFlagConfig } from '../../models/feature-flag-config.model';

// services
import API from '../../services/api';

import { useAuthSession } from '../useAuthSession';
import queryKeys from './_queryKeys';

const getConfig = async (): Promise<FeatureFlagConfig> => {
    const { data } = await API.getFeatureFlagConfig();
    return convertStringValues(data);
};

export default function useGetFeatureFlagConfig() {
    const { isAuthenticated } = useAuthSession();
    return useQuery<FeatureFlagConfig, BaseError>({
        queryKey: queryKeys.featureFlagConfig,
        queryFn: () => getConfig(),
        enabled: isAuthenticated,
        staleTime: 1000 * 24 * 60 * 60,
    });
}
